import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as React from 'react';
import { RoomsCountSelector as RoomsCountSelectorDesktop } from './views/Desktop';
import { RoomsCountSelector as RoomsCountSelectorMobile } from './views/Mobile';
import { widgetContext } from '../../context/widgetContext';
/**
 * Это generic - ui компонент, принимающий набор пропсов, среди которых value является generic-типом
 * По дефолту value V = number | string
 * Рендерит селектор комнатностей. Сейчас используется для рендеринга селектора Квартирных и ЖКшных селекторов
 * */

import { jsx as _jsx } from "react/jsx-runtime";
export var RoomsCountSelector = function RoomsCountSelector(props) {
  var _React$useContext = React.useContext(widgetContext),
      isDesktop = _React$useContext.isDesktop;

  var Component = isDesktop ? RoomsCountSelectorDesktop : RoomsCountSelectorMobile;
  return /*#__PURE__*/_jsx(Component, _objectSpread({}, props));
};
RoomsCountSelector.displayName = 'RoomsCountSelector';